define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var EventEmitter = (function () {
        function EventEmitter() {
            this.triggers = {};
        }
        EventEmitter.prototype.AddEventListener = function (eventName, callback) {
            if (!this.triggers[eventName])
                this.triggers[eventName] = [];
            this.triggers[eventName].push(callback);
            return this;
        };
        EventEmitter.prototype.FireEvent = function (eventName, eventArgs) {
            if (this.triggers[eventName]) {
                for (var _i = 0, _a = this.triggers[eventName]; _i < _a.length; _i++) {
                    var callback = _a[_i];
                    callback(this, eventArgs);
                }
            }
        };
        EventEmitter.prototype.RemoveEventListener = function (eventName, callback) {
            if (this.triggers[eventName] == undefined)
                return false;
            var index = -1;
            for (var _i = 0, _a = this.triggers[eventName]; _i < _a.length; _i++) {
                var item = _a[_i];
                if (item == callback)
                    index = this.triggers[eventName].indexOf(item);
            }
            if (index == -1)
                return false;
            this.triggers[eventName].splice(index, 1);
            return true;
        };
        return EventEmitter;
    }());
    exports.EventEmitter = EventEmitter;
    ;
});
//# sourceMappingURL=EventEmitter.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/EventEmitter.js
// module id = 23
// module chunks = 0